import type { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const developerPlatformRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import('./DeveloperPlatformScreen').then((m) => ({
        Component: m.DeveloperPlatformScreen,
      })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute
        routePath="/developer"
        linkText="Go back to the Developer Platform"
      />
    ),
  },
];
